/* import { useCurrentUser } from './useCurrentUser'; */

import { getPermissions } from 'consts';

import { useProfile } from './useProfile';

import { ROLES } from 'types';

export const useHasPermissions = (permissionNames: string | string[]) => {
  const {
    profile: { role },
  } = useProfile();
  // TODO доделать
  // @ts-ignore
  const permissions = getPermissions[role as ROLES];

  if (!permissions) {
    return false;
  }

  if (typeof permissionNames === 'string') {
    return permissions.includes?.(permissionNames);
  } else if (Array.isArray(permissionNames)) {
    return permissions.some(permissionName => permissionNames.includes?.(permissionName));
  } else {
    return false;
  }
};
